import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  padding: 0px 20px 80px 20px;
  flex-direction: column;
`;

export const TabContainer = styled.div`
  box-sizing: border-box;
  padding: 0 24px;
  width: 100%;
  height: 40px;
  align-items: center;
  display: flex;
  gap: 20px;
  border-bottom: 1px solid var(--alias-color-line-normal);
`;

export const TabItem = styled.div<{ selected: boolean }>`
  display: flex;
  flex-direction: column;
  ${(props) => props.selected && "border-bottom: 2px solid var(--alias-color-primary-normal);"}
  box-sizing: border-box;
  height: 40px;
  padding: 8px 12px;
  align-content: center;
  cursor: pointer;
`;
